import { useEffect, useRef } from "react";

const ZohoLeadForm = ({ data }) => {
  const formRef = useRef(null);

  useEffect(() => {
    if (!data || !formRef.current) return;

    const form = formRef.current;

    // ✅ Use NAME (Zoho reads this)
    form.querySelector('[name="Last Name"]').value = data.name || "";
    form.querySelector('[name="Email"]').value = data.email || "";  
    form.querySelector('[name="Mobile"]').value = data.phone || "";

    form.querySelector('[name="Description"]').value = `
      Service: ${data.crop || ""}
      City: ${data.address || ""}
      User Type: ${data.userType || ""}
    `.trim();

    // UTMs
    form.querySelector('[name="LEADCF3"]').value = data.utmSource || "-";
    form.querySelector('[name="LEADCF2"]').value = data.utmMedium || ".";
    form.querySelector('[name="LEADCF5"]').value = data.utmCampaign || "-";
    form.querySelector('[name="LEADCF4"]').value = data.utmContent || "-";

    form.submit();
  }, [data]);

  return (
    <form
      ref={formRef}
      action="https://crm.zoho.in/crm/WebToLeadForm"
      method="POST"
      acceptCharset="UTF-8"
      style={{ display: "none" }}
    >
      {/* Required tokens */}
      <input type="hidden" name="xnQsjsdp" value="6f139227e95e54b176a2ba0c9303474de842366acd466bd06f8813fcb5e65c2c" />
      <input type="hidden" name="xmIwtLD" value="6bd31c3574cede21bd8faf1d368ba3d6e282fad2208d78046f05765003aa43d995c3c3544a82a973039938d79df5247e" />
      <input type="hidden" name="actionType" value="TGVhZHM=" />
      <input type="hidden" name="returnURL" value="null" />

      {/* Fields (ID can be Last_Name, NAME must be Last Name) */}
      <input type="text" id="Last_Name" name="Last Name" />
      <input type="text" id="Email" name="Email" />
      <input type="text" id="Mobile" name="Mobile" />
      <textarea id="Description" name="Description" />

      {/* UTM fields */}
      <input type="hidden" id="LEADCF2" name="LEADCF2" />
      <input type="hidden" id="LEADCF3" name="LEADCF3" />
      <input type="hidden" id="LEADCF4" name="LEADCF4" />
      <input type="hidden" id="LEADCF5" name="LEADCF5" />
    </form>
  );
};

export default ZohoLeadForm;
